import { createSlice } from "@reduxjs/toolkit";
import { ISession } from "../interface/ISession";
import { ICategoryPrice } from "../interface/ICategoryPrice";

const initialState: ICategoryPrice | null = null;

const categoryPriceSlice = createSlice({
  name: "categoryPrice",
  initialState,
  reducers: {
    setCategoryPriceStore: (state: ISession | null, action: any | null) => {
      return action.payload;
    },
    setCategoryPriceNull: (state, action) => {
      return null;
    }
  },
});

export const { setCategoryPriceStore, setCategoryPriceNull } = categoryPriceSlice.actions;

export default categoryPriceSlice.reducer;
